import React from "react";
import styles from "./MemberCard.module.scss";
import useMemberCard from "./useMemberCard";
import MemberCardHandler from "./MemberCardHandler";

export default function MemberCard({ member }) {
  const { stateMemberCard, setMemberCard } = useMemberCard();
  const handlers = MemberCardHandler(stateMemberCard, setMemberCard);

  if (!member) return null;

  return (
    <div
      className={styles.Container}
      onMouseEnter={handlers.handleMouseEnter}
      onMouseLeave={handlers.handleMouseLeave}
    >
      <div className={styles.IconWrapper}>
        <span className="material-icons">{handlers.getIcon()}</span>
      </div>
      <div className={styles.Info}>
        <h4 className={styles.Name}>{member.name}</h4>
        <p className={styles.Title}>{member.title}</p>
        <p className={styles.Country}>
          <span className="material-icons">place</span>
          {member.country}
        </p>
      </div>
    </div>
  );
}
